import SideMenu from "../components/MyHub/SideMenu";
import nft1 from "../assets/myhub/gold_800x800.jpg";
import nft2 from "../assets/myhub/silver_800x800.jpg";
import nft3 from "../assets/myhub/black_800x800.jpg";
import coin from "../assets/myhub/coin.png";
import lpToken from "../assets/myhub/lp_token.svg";
import { useLayoutEffect, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../redux/blockchain/blockchainActions";
import { fetchHubData } from "../redux/hubdata/dataActions";
import Navbar from "../components/Navbar";
import { injected } from "../components/WalletConnector";
import { useWeb3React } from "@web3-react/core";
import { useNavigate } from "react-router-dom";
import Countdown, {zeroPad} from 'react-countdown';
import unrevealedNft from "../assets/nft2_2.jpg";

const ETHERINGWEI = 1000000000000000000;
const itemToData = {
  "1": [
    "The Other Side #5153",
    "1.png"
  ],
  "2": [
    "AlphieWhale #4001",
    "2.gif"
  ],
  "3": [
    "Bad Face Bots #744",
    "3.jpeg"
  ],
  "4": [
    "Yakuza Inc. #836",
    "4.png"
  ],
  "5": [
    "Asuna #3666",
    "5.jpeg"
  ],
  "6": [
    "AlphieWhale #2785",
    "6.png"
  ],
  "7": [
    "Satoshi Runners #6077",
    "7.gif"
  ],
  "8": [
    "Killer GF #5589",
    "8.png"
  ],
  "9": [
    "Troverse Planet #2906",
    "9.png"
  ],
  "10": [
    "Lucky Zero #1211",
    "10.png"
  ],
  "11": [
    "Funny Bone #3950",
    "11.png"
  ],
  "12": [
    "A.N.I.M.O #7940",
    "12.png"
  ],
  "13": [
    "Bad Face Bots #5484",
    "13.jpeg"
  ],
  "14": [
    "Trait Sniper Alpha Pass #2676",
    "14.png"
  ],
  "15": [
    "Satoshi Runners #839",
    "15.gif"
  ],
  "16": [
    "The Other Side #1424",
    "16.png"
  ],
  "17": [
    "Weirdo #1131",
    "17.png"
  ],
  "18": [
    "Lofi Originals #570",
    "18.png"
  ],
  "19": [
    "Lucky Zero #2369",
    "19.png"
  ],
  "20": [
    "The Other Side #7202",
    "20.png"
  ],
  "21": [
    "Alien Frens Evolution #3751",
    "21.png"
  ],
  "22": [
    "Mirror Pass #2067",
    "22.png"
  ],
  "23": [
    "Weirdo #2667",
    "23.png"
  ],
  "24": [
    "Lofi Originals #4037",
    "24.png"
  ],
  "25": [
    "Ape Reunion #8363",
    "25.png"
  ],
  "26": [
    "Blvck Genesis #923",
    "26.png"
  ],
  "27": [
    "Lunartics 5584",
    "27.png"
  ],
  "28": [
    "Arcade Land Standard #6492",
    "28.png"
  ],
  "29": [
    "The Other Side #933",
    "29.png"
  ],
  "30": [
    "Yakuza Inc. #3186",
    "30.png"
  ],
  "31": [
    "Antebellum Genesis Land #6553",
    "31.png"
  ],
  "32": [
    "Alien Frens Evolution #5145",
    "32.png"
  ],
  "33": [
    "The Other Side #1201",
    "33.png"
  ],
  "34": [
    "Funny Bone #3877",
    "34.png"
  ],
  "35": [
    "Killer GF #4290",
    "35.png"
  ],
  "36": [
    "Antebellum Genesis Land #8018",
    "36.png"
  ],
  "37": [
    "Satoshi Runners #5004",
    "37.gif"
  ],
  "38": [
    "The Other Side #6248",
    "38.png"
  ],
  "39": [
    "Yakuza Inc. #1575",
    "39.png"
  ],
  "40": [
    "Lunartics 6419",
    "40.png"
  ],
  "41": [
    "Alien Frens Evolution #10281",
    "41.png"
  ],
  "42": [
    "Trait Sniper Alpha Pass #2896",
    "14.png"
  ],
  "43": [
    "Night City / The Beginning / 01",
    "43.png"
  ],
  "44": [
    "The Other Side #7321",
    "44.png"
  ],
  "45": [
    "Killer GF #3703",
    "45.png"
  ],
  "46": [
    "Bad Face Bots #5048",
    "46.png"
  ],
  "47": [
    "E-Shell #0272",
    "47.png"
  ],
  "48": [
    "Shinsekai #7661",
    "48.png"
  ],
  "49": [
    "Lunartics 5595",
    "49.png"
  ],
  "50": [
    "E-Shell #4210",
    "50.png"
  ],
  "51": [
    "A.N.I.M.O #2280",
    "51.png"
  ],
  "52": [
    "Night City / The Beginning / 01",
    "43.png"
  ],
  "53": [
    "Shinsekai #5613",
    "53.png"
  ],
  "54": [
    "Something Token 7804",
    "54.png"
  ],
  "55": [
    "Shinsei Galverse #3836",
    "55.png"
  ],
  "56": [
    "Land of Valeria #2600",
    "56.png"
  ],
  "57": [
    "Atmos #5318",
    "57.png"
  ],
  "58": [
    "Land of Valeria #2601",
    "58.png"
  ],
  "59": [
    "Atmos #3277",
    "59.png"
  ],
  "60": [
    "E-Shell #3160",
    "60.png"
  ],
  "61": [
    "Weirdo #130",
    "61.png"
  ],
  "62": [
    "Yakuza Inc. #1751",
    "62.png"
  ],
  "63": [
    "E-Shell #7218",
    "63.png"
  ],
  "64": [
    "Night City / The Beginning / 01",
    "43.png"
  ],
  "65": [
    "Land of Valeria #3032",
    "65.png"
  ],
  "66": [
    "Shinsekai #1911",
    "66.png"
  ],
  "67": [
    "Satoshi Runners #6225",
    "67.png"
  ],
  "68": [
    "Lunartics 7859",
    "68.png"
  ],
  "69": [
    "GENE_SIS #6367",
    "69.png"
  ],
  "70": [
    "Bao Society #178",
    "70.png"
  ],
  "71": [
    "Asuna #8542",
    "71.png"
  ],
  "72": [
    "Bao Society #2893",
    "72.png"
  ],
  "73": [
    "Shinsekai #6728",
    "73.png"
  ],
  "74": [
    "Arcade Land Standard #5412",
    "74.png"
  ],
  "75": [
    "Shinsekai #7643",
    "75.png"
  ],
  "76": [
    "E-Shell #0865",
    "76.png"
  ],
  "77": [
    "GENE_SIS #6137",
    "77.png"
  ],
  "78": [
    "Arcade Land Standard #7113",
    "78.png"
  ],
  "79": [
    "E-Shell #1920",
    "79.png"
  ],
  "80": [
    "Asuna #3827",
    "80.png"
  ],
  "81": [
    "Killer GF #4599",
    "81.png"
  ],
  "82": [
    "Egao #248",
    "82.png"
  ],
  "83": [
    "MURI [7566]",
    "83.png"
  ],
  "84": [
    "Egao #7378",
    "84.png"
  ],
  "85": [
    "MURI [8742]",
    "85.png"
  ],
  "86": [
    "Egao #7358",
    "86.png"
  ],
};

const poolPositionAddress = "0xc36442b4a4522e871399cd717abdd847ab11fe88";
const poolStakerAddress = "0xe34139463bA50bD61336E0c446Bd8C0867c6fE65";
const poolIncentive = "0x000000000000000000000000e81b6ef5ef04972d9d0548848024058b59d00ff0000000000000000000000000b690cb96839fe494a7427f9bb1da922872f4e2d200000000000000000000000000000000000000000000000000000000627333880000000000000000000000000000000000000000000000000000000062f07208000000000000000000000000c932c7e17fec62863ffd630a254fa780eed88ac5";
const deyeAddress = '0xE81b6ef5eF04972D9d0548848024058b59d00Ff0';

const getItemName = (itemId) => {
  if (!(itemId in itemToData)) {
    return ""
  }
  return itemToData[itemId][0];
}

const getItemImage = (itemId) => {
  if (!(itemId in itemToData)) {
    return ""
  }
  return "https://storage.googleapis.com/project_dark_eye_public/marketplace/" + itemToData[itemId][1];
}

const ExpectedReturn = (days, blockchain, data) => {
  var dailyRemaining = 1.0 - 300 * 0.0000005 - 1000 * 0.0000002 - 122 * 0.00000005 - 500 * 0.00000005;
  var percentage = blockchain.goldCount * 0.0000005 + blockchain.silverCount * 0.0000002 + blockchain.blackCount * 0.00000005;
  var pool = blockchain.remainingPool;
  var rt = 0.0;
  for (var i = 0; i < days; i++) {
    rt = rt + pool;
    pool = pool * dailyRemaining;
  }
  rt = rt * percentage;
  return rt;
}

const CommanderExpectedReturn = (days, blockchain, data) => {
  var dailyRemaining = 1.0 - 300 * 0.0000005 - 1000 * 0.0000002 - 122 * 0.00000005 - 500 * 0.00000005;
  var percentage = parseFloat(data.commanderCount) * 0.000001;
  var pool = blockchain.remainingPool;
  var rt = 0.0;
  for (var i = 0; i < days; i++) {
    rt = rt + pool;
    pool = pool * dailyRemaining;
  }
  rt = rt * percentage;
  return rt;
}

const TotalExpectedReturn = (days, blockchain, data) => {
  return ExpectedReturn(days, blockchain, data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " (TM) + " + CommanderExpectedReturn(days, blockchain, data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " (C)";
}

const MyHub = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [component, setComponent] = useState("home");
  const blockchain = useSelector((state) => state.blockchain);
  const { activate, deactivate } = useWeb3React();
  const data = useSelector((state) => state.data);
  const hubData = useSelector((state) => state.hubData);
  console.log(hubData, blockchain.deyeBalance, hubData.deyeClaimed, blockchain.deyeBalance-hubData.deyeClaimed, blockchain.deyeProof);

  useLayoutEffect(() => {
    const connectWalletOnPageLoad = async () => {
      if (localStorage?.getItem("isWalletConnected") === "true") {
        try {
          dispatch(connect());
          await activate(injected);
          localStorage.setItem("isWalletConnected", true);
        } catch (ex) {
          console.log(ex);
        }
      }
    };
    connectWalletOnPageLoad();
  }, []);

  async function disconnect() {
    try {
      deactivate();
      localStorage.setItem("isWalletConnected", false);
    } catch (ex) {
      console.log(ex);
    }
  }

  const claimDeye = () => {
    blockchain.deyeContract.methods
      .claim(blockchain.deyeBalance-hubData.deyeClaimed, blockchain.deyeBalance, blockchain.deyeProof)
      .send({
        gasLimit: String(150000),
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
      })
      .then((receipt) => {
        console.log(receipt);
        dispatch(fetchHubData(blockchain.account));
      });
  };

  const buyItem = (item) => {
    if (hubData.marketDeyeAllowance < item.currentPrice) {
      blockchain.deyeContract.methods
        .approve("0xa68f3dbf1bfe72dfe84b6eec568bd6ed76e2b02b", "10000000000000000000000000000")
        .send({
          gasLimit: String(100000),
          from: blockchain.account,
        })
        .once("error", (err) => {
          console.log(err);
        })
        .then((r) => {
          console.log("Buying:"+item);
          blockchain.marketContract.methods
            .buyItem(item.item.id, item.currentPrice)
            .send({
              gasLimit: String(500000),
              from: blockchain.account,
            })
            .once("error", (err) => {
              console.log(err);
            })
            .then((receipt) => {
              dispatch(fetchHubData(blockchain.account));
            });
        });
    } else {
      console.log("Buying:"+item);
      blockchain.marketContract.methods
        .buyItem(item.item.id, item.currentPrice)
        .send({
          gasLimit: String(500000),
          from: blockchain.account,
        })
        .once("error", (err) => {
          console.log(err);
        })
        .then((receipt) => {
          dispatch(fetchHubData(blockchain.account));
        });
    }
  };

  const stakePoolToken = (tokenId) => {
    blockchain.poolPositionContract.methods
      .safeTransferFrom(blockchain.account, poolStakerAddress, tokenId, poolIncentive)
      .send({
        gasLimit: String(330000),
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
      })
      .then((receipt) => {
        dispatch(fetchHubData(blockchain.account));
      });
  };

  const unstakePoolToken = (tokenId) => {
    const unstakeCall = blockchain.stakerContract.methods.unstakeToken(
      ["0xE81b6ef5eF04972D9d0548848024058b59d00Ff0","0xb690cb96839fe494a7427f9bb1da922872f4e2d2",1651717000,1659925000,"0xC932C7E17fec62863fFd630a254Fa780EED88ac5"],
      tokenId
    ).encodeABI();
    const claimCall = blockchain.stakerContract.methods.claimReward(
      deyeAddress,
      blockchain.account,
      "10000000000000000000000000000"
    ).encodeABI();
    const withdrawCall = blockchain.stakerContract.methods.withdrawToken(
      tokenId,
      blockchain.account,
      "0x0000000000000000000000000000000000000000"
    ).encodeABI();
    blockchain.stakerContract.methods
      .multicall([unstakeCall, claimCall, withdrawCall])
      .send({
        gasLimit: String(330000),
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
      })
      .then((receipt) => {
        dispatch(fetchHubData(blockchain.account));
      });
  };

  const renderer = ({ days, hours, minutes, seconds }) => (
    <span>
      { days > 0 ? (
        <>
          {days} Days {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
        </>
      ) : (
        <>
          { hours > 0 ? (
              <> {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)} </>
            ) : (
              <> {zeroPad(minutes)}:{zeroPad(seconds)} </>
            )
          }
        </>
      )}
    </span>
  );

  return (
    <>
      <div className="bg-mint bg-center bg-cover bg-no-repeat bg-fixed min-h-screen text-white relative">
        <div className="bg-blackOverlay min-h-screen">
          {blockchain.loading ? (
            <svg
              role="status"
              className="inline w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 absolute top-[50%] left-[50%]"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : (
            <>
              {blockchain.account === null ? (
                <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center">
                  <h1 className="text-lg sm:text-2xl">
                    Please connect your wallet to access this page
                  </h1>
                  <button
                    onClick={() => {
                      navigate("/");
                    }}
                    className="py-3 px-4 bg-pinkD hover:bg-pink-800 rounded-md text-white mt-5"
                  >
                    Back to home
                  </button>
                </div>
              ) : (
                <>
                  {true || (blockchain.goldCount + blockchain.silverCount + blockchain.blackCount + blockchain.deyeBalance > 0) ? (
                    <>
                      {component === "home" && (
                        <>
                          <Navbar disconnect={disconnect} />
                          <div className="font-face-1 pt-32 lg:pt-36">
                            <div className="grid lg:grid-cols-12 gap-5">
                              <div className="lg:col-span-2">
                                <SideMenu
                                  component={component}
                                  setComponent={setComponent}
                                />
                              </div>

                              <div className="lg:col-span-9 py-5 px-5 lg:px-0">
                                <h1 className="text-3xl md:text-4xl font-semibold">
                                  DEYE Token
                                </h1>

                                <div className="bg-hub bg-center bg-cover bg-no-repeat rounded-lg p-3 sm:p-10 mt-10">
                                  <div className="grid md:grid-cols-12 gap-10">
                                    <div className="md:col-span-4">
                                      <img
                                        src={coin}
                                        alt="coin"
                                        className="object-fill mx-auto"
                                      />
                                    </div>

                                    <div className="md:col-span-8 mt-7">

                                      <div className="p-5 bg-pinkD rounded-md">
                                        <div className="sm:flex items-center sm:space-x-20">
                                          <p className="text-xl mt-3 mb-3">
                                            Balance: <span className="font-bold text-4xl">
                                              {parseFloat(hubData.deyeInWallet).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                            </span>
                                            DEYE
                                          </p>
                                          <a
                                            href="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0xe81b6ef5ef04972d9d0548848024058b59d00ff0&chain=mainnet"
                                            target="_blank"
                                            className="py-3 px-4 bg-white hover:bg-yellow-200 rounded-md lg:mr-8 ml-5 mt-1 mb-1"
                                          >
                                            <span className="text-black">BUY</span>
                                          </a>
                                        </div>
                                      </div>

                                      <div className="p-5 bg-pinkD rounded-md mt-5">
                                        <div className="sm:flex items-center sm:space-x-20">
                                          <p className="text-xl mt-3 mb-3">
                                            Claimable: <span className="font-bold text-4xl">
                                              {blockchain.deyeBalance && parseFloat(blockchain.deyeBalance-hubData.deyeClaimed).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                            </span>
                                            DEYE
                                          </p>
                                          {blockchain.deyeProof != "" && blockchain.deyeBalance-hubData.deyeClaimed > 0 && Date.now() >= 1651723200000 && (
                                            <>
                                            <button
                                              className="py-3 px-4 bg-white hover:bg-black rounded-md text-black hover:text-white lg:mr-8 ml-5 mt-1 mb-1"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                claimDeye();
                                              }}
                                            >
                                              CLAIM
                                            </button>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <h1 className="text-3xl md:text-4xl font-semibold mt-20">
                                  DEYE-ETH Liquidity Pool
                                </h1>

                                <div className="bg-hub bg-center bg-cover bg-no-repeat rounded-lg p-3 sm:p-10 mt-10">
                                  <div className="grid md:grid-cols-12 gap-10">
                                    <div className="md:col-span-4">
                                      <img
                                        src={lpToken}
                                        alt="lpToken"
                                        className="object-fill mx-auto"
                                      />
                                    </div>

                                    <div className="md:col-span-8 mt-1">

                                      <div className="p-5 bg-pinkD rounded-md">
                                        <div className="sm:flex items-center sm:space-x-20">
                                          <p className="text-xl mt-3 mb-3">
                                            Pool: <span className="font-bold text-4xl">
                                              {parseFloat(hubData.poolDeye).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                            </span>
                                            DEYE
                                             {/* / <span className="font-bold text-4xl">
                                              {parseFloat(hubData.poolEth).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                            </span>
                                            ETH */}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="p-5 bg-pinkD rounded-md mt-5">
                                        <div className="sm:flex items-center sm:space-x-20">
                                          <p className="text-xl mt-3 mb-3">
                                            APR: <span className="font-bold text-4xl">
                                              {parseFloat(1000000*365*100/2/hubData.poolDeye).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                            </span>
                                            %
                                          </p>
                                          <a
                                            href="https://app.uniswap.org/#/add/ETH/0xe81b6ef5ef04972d9d0548848024058b59d00ff0/3000?chain=mainnet"
                                            target="_blank"
                                            className="py-3 px-4 bg-white hover:bg-yellow-200 rounded-md lg:mr-8 ml-5 mt-1 mb-1"
                                          >
                                            <span className="text-black">Add to Pool</span>
                                          </a>
                                        </div>
                                      </div>

                                      {hubData.poolPositions && hubData.poolPositions.length > 0 && (
                                        <>
                                          <h1 className="mt-8 text-2xl font-medium">
                                            Your Positions (Unstaked)<br/>
                                          </h1>
                                          {hubData.poolPositions.map((position) => (
                                            <div className="p-5 bg-pinkD rounded-md mt-5">
                                              <div className="sm:flex items-center sm:space-x-20">
                                                <p className="text-xl mt-1 mb-1">
                                                  Position ID: <span className="font-bold text-4xl">
                                                    {position.id}
                                                  </span>
                                                  <a href={"https://opensea.io/assets/" + poolPositionAddress + "/" + position.id} target="_blank">
                                                    <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                                      <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                                      </svg>
                                                    </button>
                                                  </a>
                                                </p>
                                                <button
                                                  className="py-3 px-4 bg-white hover:bg-black rounded-md text-black hover:text-white lg:mr-8 ml-5 mt-1 mb-1"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    stakePoolToken(position.id);
                                                  }}
                                                >
                                                  STAKE
                                                </button>
                                              </div>
                                            </div>
                                          ))}
                                        </>
                                        )
                                      }

                                      {hubData.stakedPositions && hubData.stakedPositions.length > 0 ? (
                                        <>
                                          <h1 className="mt-8 text-2xl font-medium">
                                            Your Positions (Staked)<br/>
                                          </h1>
                                          {hubData.stakedPositions.map((position) => (
                                            <>
                                              <div className="p-5 bg-pinkD rounded-md mt-5">
                                                <div className="sm:flex items-center sm:space-x-20">
                                                  <p className="text-xl mt-1 mb-1">
                                                    Position ID: <span className="font-bold text-4xl">
                                                      {position.id}
                                                    </span>
                                                    <a href={"https://opensea.io/assets/" + poolPositionAddress + "/" + position.id} target="_blank">
                                                      <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                                        <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                                        </svg>
                                                      </button>
                                                    </a>
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="p-5 bg-pinkD rounded-md mt-5">
                                                <div className="sm:flex items-center sm:space-x-20">
                                                  <p className="text-xl mt-1 mb-1">
                                                    Earned: <span className="font-bold text-4xl">
                                                      {parseFloat(position.reward/1000000000000000000).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                                                    </span>
                                                    DEYE
                                                  </p>
                                                </div>
                                              </div>
                                              <button
                                                className="py-3 px-4 bg-white hover:bg-black rounded-md text-black hover:text-white lg:mr-8 mt-5 mb-1"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  unstakePoolToken(position.id);
                                                }}
                                              >
                                                UNSTAKE + CLAIM REWARDS
                                              </button>
                                            </>
                                          ))}
                                        </>
                                        ) : (
                                          <>
                                          <h1 className="mt-5 mb-10 text-xs font-medium">
                                            (Staked tokens can take up to 30 minutes to show up)
                                          </h1>
                                          </>
                                        )
                                      }

                                      {/* <h1 className="mt-8 text-2xl font-medium">
                                        Earning Estimates<br/>
                                      </h1>

                                      <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 mt-6">
                                        <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                          <span className="font-bold text-xl">{ExpectedReturn(1, blockchain, data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </span> / 24 hours
                                        </p>
                                        <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                          <span className="font-bold text-xl">{ExpectedReturn(7, blockchain, data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </span> / 7 Days
                                        </p>
                                      </div>

                                      <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 mt-3">
                                        <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                          <span className="font-bold text-xl">{ExpectedReturn(30, blockchain, data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </span> / 30 Days
                                        </p>
                                        <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                          <span className="font-bold text-xl">{ExpectedReturn(365, blockchain, data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </span> / 365 Days
                                        </p>
                                      </div>

                                      <h1 className="mt-5 text-xs font-medium">
                                        (based on the current pool size and machine ownerships)
                                      </h1> */}
                                    </div>
                                  </div>
                                </div>

                                <h1 className="text-3xl md:text-4xl font-semibold mt-20">
                                  Time Machine
                                </h1>
                                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-20 mb-10">
                                  <div
                                    key="1"
                                    className="border-2 p-2 border-white"
                                  >
                                    <img
                                      src={nft1}
                                      alt="nft1"
                                      className="object-fill mx-auto rounded-t-md"
                                    />
                                    <h1
                                      className="p-2 rounded-b-md font-bold text-2xl text-center bg-white text-pinkD"
                                    >
                                      Owned: {blockchain.goldCount}
                                      <a href="https://opensea.io/collection/time-machines-by-project-dark-eye?search[sortAscending]=true&search[sortBy]=PRICE&search[stringTraits][0][name]=Quality&search[stringTraits][0][values][0]=%7C%20Gold%20%7C" target="_blank">
                                        <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                          <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                          </svg>
                                        </button>
                                      </a>
                                    </h1>
                                  </div>
                                  <div
                                    key="2"
                                    className="border-2 p-2 border-white"
                                  >
                                    <img
                                      src={nft2}
                                      alt="nft2"
                                      className="object-fill mx-auto rounded-t-md"
                                    />
                                    <h1
                                      className="p-2 rounded-b-md font-bold text-2xl text-center bg-white text-pinkD"
                                    >
                                      Owned: {blockchain.silverCount}
                                      <a href="https://opensea.io/collection/time-machines-by-project-dark-eye?search[sortAscending]=true&search[sortBy]=PRICE&search[stringTraits][0][name]=Quality&search[stringTraits][0][values][0]=%7C%20Silver%20%7C" target="_blank">
                                        <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                          <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                          </svg>
                                        </button>
                                      </a>
                                    </h1>
                                  </div>
                                  <div
                                    key="3"
                                    className="border-2 p-2 border-white"
                                  >
                                    <img
                                      src={nft3}
                                      alt="nft3"
                                      className="object-fill mx-auto rounded-t-md"
                                    />
                                    <h1
                                      className="p-2 rounded-b-md font-bold text-2xl text-center bg-white text-pinkD"
                                    >
                                      Owned: {blockchain.blackCount}
                                      <a href="https://opensea.io/collection/time-machines-by-project-dark-eye?search[sortAscending]=true&search[sortBy]=PRICE&search[stringTraits][0][name]=Quality&search[stringTraits][0][values][0]=%7C%20Black%20%7C" target="_blank">
                                        <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                          <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                          </svg>
                                        </button>
                                      </a>
                                    </h1>
                                  </div>
                                </div>
                                <h1 className="text-3xl md:text-4xl font-semibold mt-20">
                                  DEYE Yielding Estimates<br/>
                                </h1>

                                <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 mt-6">
                                  <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                    <span className="font-bold text-xl">{TotalExpectedReturn(1, blockchain, hubData)} </span> / 24 hours
                                  </p>
                                  <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                    <span className="font-bold text-xl">{TotalExpectedReturn(7, blockchain, hubData)} </span> / 7 Days
                                  </p>
                                </div>

                                <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 mt-3">
                                  <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                    <span className="font-bold text-xl">{TotalExpectedReturn(30, blockchain, hubData)} </span> / 30 Days
                                  </p>
                                  <p className="p-2 text-sm border border-white/30 bg-white/10 rounded-md">
                                    <span className="font-bold text-xl">{TotalExpectedReturn(365, blockchain, hubData)} </span> / 365 Days
                                  </p>
                                </div>

                                <h1 className="mt-5 mb-10 text-xs font-medium">
                                  (based on the current pool size and machine ownerships, TM=Time Machine / C=Commander)
                                </h1>

                                
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {component === "marketplace" && (
                        <>
                          <Navbar disconnect={disconnect} />
                          <div className="font-face-1 pt-32 lg:pt-36">
                            <div className="grid lg:grid-cols-12 gap-5">
                              <div className="lg:col-span-2">
                                <SideMenu
                                  component={component}
                                  setComponent={setComponent}
                                />
                              </div>

                              <div className="lg:col-span-9 py-5 px-5 lg:px-0">
                                {hubData.activeItems && hubData.activeItems.length > 0 && (
                                  <>
                                    <h1 className="text-3xl md:text-4xl font-semibold">
                                      Active Listings
                                    </h1>
                                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-20 mb-20 font-def">
                                      {hubData.activeItems.map((item) => (
                                        <div
                                          className="border-2 p-5 border-pinkD bg-white/[.2] rounded-md"
                                        >
                                          <img
                                            src={getItemImage(item.item.id)}
                                            className="object-fill mx-auto rounded-md"
                                          />
                                          <div className="mt-5">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              {getItemName(item.item.id)}
                                              <a href={"https://opensea.io/assets/" + item.item.nft + "/" + item.item.tokenId} target="_blank">
                                                <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                                  <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                                  </svg>
                                                </button>
                                              </a>
                                            </h1>
                                          </div>
                                          <div className="mt-2">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              Price: <span className="text-red-500">{parseFloat(item.currentPrice/ETHERINGWEI).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} DEYE</span>
                                            </h1>
                                          </div>
                                          <div className="mt-2 text-center">
                                            {item.currentPrice/ETHERINGWEI > hubData.deyeInWallet ? (
                                              <button
                                                className="py-3 px-4 bg-pinkD hover:bg-white rounded-md text-white hover:text-pinkD mt-1 mb-1 font-face-1"
                                              >
                                                NOT ENOUGH DEYE
                                              </button>
                                            ) : (
                                              <button
                                                className="py-3 px-4 bg-pinkD hover:bg-white rounded-md text-white hover:text-pinkD mt-1 mb-1 font-face-1"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  buyItem(item);
                                                }}
                                              >
                                                BUY NOW
                                              </button>
                                            )}
                                          </div>
                                          <div className="mt-2">
                                            <h1
                                              className="rounded-b-md font-bold text-xl text-center text-white"
                                            >
                                              Next Price: {parseFloat(item.nextPrice/ETHERINGWEI).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} DEYE in <Countdown date={parseFloat(item.nextPriceTime)*1000} renderer={renderer}/>
                                            </h1>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )}

                                {hubData.notStartedItems && hubData.notStartedItems.length > 0 && (
                                  <>
                                    <h1 className="text-3xl md:text-4xl font-semibold">
                                      Not Started
                                    </h1>
                                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-20 mb-20 font-def">
                                      {hubData.notStartedItems.map((item) => (
                                        <div
                                          className="border-2 p-5 border-pinkD bg-white/[.2] rounded-md"
                                        >
                                          <img
                                            src={getItemImage(item.item.id)}
                                            className="object-fill mx-auto rounded-md"
                                          />
                                          <div className="mt-5">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              {getItemName(item.item.id)}
                                              <a href={"https://opensea.io/assets/" + item.item.nft + "/" + item.item.tokenId} target="_blank">
                                                <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                                  <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                                  </svg>
                                                </button>
                                              </a>
                                            </h1>
                                          </div>
                                          <div className="mt-2">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              Starting in <Countdown date={parseFloat(item.item.startingTime)*1000} renderer={renderer}/>
                                            </h1>
                                          </div>
                                          <div className="mt-2">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              Starting Price: <span className="text-red-500">{parseFloat(item.currentPrice/ETHERINGWEI).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} DEYE</span>
                                            </h1>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )}

                                {hubData.soldItems && hubData.soldItems.length > 0 && (
                                  <>
                                    <h1 className="text-3xl md:text-4xl font-semibold">
                                      Sold Listings
                                    </h1>
                                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-20 mb-20 font-def">
                                      {hubData.soldItems.map((item) => (
                                        <div
                                          className="border-2 p-5 border-pinkD bg-white/[.2] rounded-md"
                                        >
                                          <img
                                            src={getItemImage(item.item.id)}
                                            className="object-fill mx-auto rounded-md"
                                          />
                                          <div className="mt-5">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              {getItemName(item.item.id)}
                                              <a href={"https://opensea.io/assets/" + item.item.nft + "/" + item.item.tokenId} target="_blank">
                                                <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                                  <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                                  </svg>
                                                </button>
                                              </a>
                                            </h1>
                                          </div>
                                          <div className="mt-2">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              Sold Price: <span className="text-red-500">{parseFloat(item.item.soldPrice/ETHERINGWEI).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} DEYE</span>
                                            </h1>
                                          </div>
                                          <div className="mt-2">
                                            <h1
                                              className="rounded-b-md font-bold text-2xl text-center text-white"
                                            >
                                              ({new Date(item.item.soldTime*1000).toLocaleString("en-US")})
                                            </h1>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {component === "commander" && blockchain.commanderTokenIds.length > 0 && (
                        <>
                          <Navbar disconnect={disconnect} />
                          <div className="font-face-1 pt-32 lg:pt-36">
                            <div className="grid lg:grid-cols-12 gap-5">
                              <div className="lg:col-span-2">
                                <SideMenu
                                  component={component}
                                  setComponent={setComponent}
                                />
                              </div>

                              <div className="lg:col-span-9 py-5 px-5 lg:px-0">
                                <h1 className="text-3xl md:text-4xl font-semibold">
                                  Commanders
                                </h1>
                                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-20 mb-20 font-def">
                                  {blockchain.commanderTokenIds.map((commanderId) => (
                                    <div
                                      className="border-2 p-5 border-pinkD bg-white/[.2] rounded-md"
                                    >
                                      <img
                                        src={unrevealedNft}
                                        className="object-fill mx-auto rounded-md"
                                      />
                                      <div className="mt-5">
                                        <h1
                                          className="rounded-b-md font-bold text-2xl text-center text-white"
                                        >
                                          {"Commander #" + commanderId}
                                          <a href={"https://opensea.io/assets/0x6d0065855d7171937ed49e60c316d2fb07200c0b/" + commanderId} target="_blank">
                                            <button className="ml-3 p-1.5 rounded-full bg-[#EA5262]">
                                              <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z" fill="white"/>
                                              </svg>
                                            </button>
                                          </a>
                                        </h1>
                                      </div>
                                      <div className="mt-2">
                                        <h1 className="rounded-b-md font-bold text-2xl text-center text-pink-500">
                                          Level: <span className="text-pink-500">1</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white mt-2">
                                          Leadership: <span className="text-red-500">?</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white">
                                          Intelligence: <span className="text-red-500">?</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white">
                                          Agility: <span className="text-red-500">?</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white">
                                          Perception: <span className="text-red-500">?</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white">
                                          Instinct: <span className="text-red-500">?</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white">
                                          Creativity: <span className="text-red-500">?</span>
                                        </h1>
                                        <h1 className="rounded-b-md font-bold text-xl text-center text-white mt-2">
                                          Base: Planet #0
                                        </h1>
                                        {/* <a href={"https://docs.google.com/forms/d/e/1FAIpQLSfeS4_LWQelWmDiCmaah-If9YbnaFQ3E6dTHkJoaXdwQ8xPOQ/viewform?usp=pp_url&entry.1166656575=" + (7*parseInt(commanderId)*parseInt(commanderId)+parseInt(commanderId)*7717+3331).toString()} target="_blank">
                                          <h1 className="rounded-b-md font-bold text-xl text-center text-red-500 mt-2 underline">
                                            Submit name proposal
                                          </h1>
                                        </a> */}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center">
                      <h1 className="font-bold text-lg sm:text-2xl">
                        My Hub is only available to Time Machine holders at this moment
                      </h1>
                      <button
                        onClick={() => {
                          navigate("/");
                        }}
                        className="font-bold py-3 px-4 bg-pinkD hover:bg-pink-800 rounded-md text-white mt-5"
                      >
                        Go to Mint
                      </button>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MyHub;
